import React from 'react';
import '../pages/ticket.css';
import scenicImage from '../assests/umiam.png'; // Scenic background image path
import radialLogo from '../assests/Layer_1 (5).png'; // Radial logo image path
import vipTicket from '../assests/Untitled design (13).png'; // VIP ticket image path
import festivalPass from '../assests/Untitled design (14).png'; // Festival Pass image path
import day1Pass from '../assests/Untitled design (16).png'; // Day 1 Pass image path
import day2Pass from '../assests/Untitled design (15).png'; // Day 2 Pass image path

const TicketPage = () => {
  return (
    <main className="ticket-page" aria-label="The Hills Festival tickets information">
      {/* Enclosing Rectangle for the Header */}
      <header className="header-container-ticket">
        <img src={radialLogo} alt="The Hills Festival logo" className="header-logo" />
        <h1 className="header-title-ticket">TICKETS</h1>
      </header>

      {/* Placeholder for Scenic Image */}
      <div className="scenic-image-container">
        <img src={scenicImage} alt="Umiam Lake scenic view at The Hills Festival location" className="scenic-image" />
      </div>

      {/* Additional Content Below */}
      <section className="description-section-ticket">
        <h2>SHOWCASING THE BEST</h2>
        <h3>ONLY, THE VERY BEST</h3>
        <p>
          Established in 2018, The Hills Festival showcases Meghalaya's vibrant
          culture over two days, blending modernity and tradition. Set against
          the stunning Umiam Lake, it features global talents and promotes
          eco-consciousness. Join us in 2026 for a memorable celebration of
          music, art, and local heritage.Stay tuned for ticket details and get ready to experience the magic of The Hills Festival!
        </p>
        <p>The Hills Festival Previous Edition Tickets(2024)</p>
      </section>

      <section className="ticket-options" aria-label="Available ticket options">
        <img src={vipTicket} alt="The Hills Festival 2024 VIP Admission Pass ticket" className="ticket-image" />
        <img src={festivalPass} alt="The Hills Festival 2024 Festival Pass ticket" className="ticket-image" />
        <img src={day1Pass} alt="The Hills Festival 2024 Day 1 Pass ticket" className="ticket-image" />
        <img src={day2Pass} alt="The Hills Festival 2024 Day 2 Pass ticket" className="ticket-image" />
      </section>
    </main>
  );
};

export default TicketPage;